// @flow

//
// React
//
import React from 'react';

//
// Formatter
//
import { fmtQuantity } from '../../../../../lib/trix-web-data-commons';

//
// Cell renderer
//
import {
    createItemSubItemCellRenderer,
} from '../../../../../lib/trix-web-components-table';

const createPurchaseOrderLineQuantitiesTableColumn = (cfg: any): any => {
    return {
        align: 'right',
        flex: false,
        width: 120,

        renderCell: createItemSubItemCellRenderer({
            ...cfg.cellRendererFactoryProps,

            align: 'right',

            getItem: (props: any) => {
                return fmtQuantity((props.row && props.row.quantity) ? 
                        props.row.quantity : undefined);
            },

            getSubItem: (props: any) => {
                const deliveredQuantity = (props.row && props.row.soldQuantity) ? props.row.deliveredQuantity : {
                    amount: 0.0, 
                    unit: '-'
                };
                const returnedQuantity = (props.row && props.row.returnedQuantity) ? props.row.returnedQuantity : {
                    amount: 0.0, 
                    unit: '-'
                };
                return `${fmtQuantity(deliveredQuantity)} (${fmtQuantity(returnedQuantity)})`;
            }
        })
    }
}
export default createPurchaseOrderLineQuantitiesTableColumn;